import useFetch from '../../../hooks/useFetch';
import { ServiceEvents, ServiceEventsDocuments } from '../shared/interfaces';
import { useState } from 'react';
import { EndPoints } from '../EndPoints';
import { BatchDataForm, BatchFilters } from '../../models/Batch';
import { getFetchDefaultHeaders } from '../shared/vars';

const useBatchService = () => {
  const { doGet, doPost, doPut, doDelete, doGetDocument } = useFetch();

  const [fetchingGetBatches, setFetchingGetBatches] = useState(false);
  const [fetchingExportBatchesExcel, setFetchingExportBatchesExcel] = useState(false);
  const [fetchingShowBatch, setFetchingShowBatch] = useState(false);
  const [fetchingCreateBatch, setFetchingCreateBatch] = useState(false);
  const [fetchingStoreBatch, setFetchingStoreBatch] = useState(false);
  const [fetchingEditBatch, setFetchingEditBatch] = useState(false);
  const [fetchingUpdateBatch, setFetchingUpdateBatch] = useState(false);
  const [fetchingDeleteBatch, setFetchingDeleteBatch] = useState(false);
  const [fetchingActiveBatch, setFetchingActiveBatch] = useState(false);

  const getBatches = (filters: BatchFilters, events: ServiceEvents = {}) => {
    const queryString = Object.entries(filters)
      .filter(([, v]) => v !== null && v !== undefined && v !== '')
      .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
      .join('&');
    doGet({ ...events, url: `${EndPoints.BATCHES.GET_BATCHES}?${queryString}`, setFetching: setFetchingGetBatches });
  };

  /** Exporta todos los lotes que coincidan con los filtros (sin paginar). page/per_page se omiten. */
  const exportBatchesExcel = (filters: BatchFilters, events: ServiceEventsDocuments = {}) => {
    const { page: _p, per_page: _pp, ...rest } = filters;
    const queryString = Object.entries(rest)
      .filter(([, v]) => v !== null && v !== undefined && v !== '')
      .map(([k, v]) => `${k}=${encodeURIComponent(String(v))}`)
      .join('&');
    const url = `${EndPoints.BATCHES.GET_EXCEL_BATCHES}?${queryString}`;
    doGetDocument({
      ...events,
      url,
      successData: {
        nameDocument: 'lotes.xlsx',
        message: 'Archivo descargado correctamente.'
      },
      setFetching: setFetchingExportBatchesExcel
    });
  };

  const createBatch = (events: ServiceEvents = {}) =>
    doGet({ ...events, url: EndPoints.BATCHES.CREATE_BATCH, setFetching: setFetchingCreateBatch });

//   const showBatch = (id: number, events: ServiceEvents = {}) =>
//     doGet({ ...events, url: EndPoints.BATCHES.SHOW_BATCH.replace(':id', id.toString()), setFetching: setFetchingShowBatch });

  const storeBatch = (data: BatchDataForm, events: ServiceEvents = {}) =>
    doPost({ ...events, url: EndPoints.BATCHES.STORE_BATCH, body: data, setFetching: setFetchingStoreBatch });

  const editBatch = (id: number, events: ServiceEvents = {}) =>
    doGet({ ...events, url: EndPoints.BATCHES.EDIT_BATCH.replace(':id', id.toString()), setFetching: setFetchingEditBatch });

  const updateBatch = (id: number, data: BatchDataForm, events: ServiceEvents = {}) =>
    doPut({ ...events, url: EndPoints.BATCHES.UPDATE_BATCH.replace(':id', id.toString()), body: data, setFetching: setFetchingUpdateBatch });

  const deleteBatch = (id: number, events: ServiceEvents = {}) =>
    doDelete({ ...events, url: EndPoints.BATCHES.DELETE_BATCH.replace(':id', id.toString()), setFetching: setFetchingDeleteBatch });

  const activeBatch = (id: number, active: boolean, events: ServiceEvents = {}) =>
    doPost({ ...events, url: EndPoints.BATCHES.ACTIVE_BATCH.replace(':id', id.toString()), body: { active }, setFetching: setFetchingActiveBatch });

  const [fetchingCloneBatch, setFetchingCloneBatch] = useState(false);
  
  const cloneBatch = (id: number, events: ServiceEvents = {}) =>
    doPost({ ...events, url: EndPoints.BATCHES.CLONE_BATCH.replace(':id', id.toString()), setFetching: setFetchingCloneBatch });

  const openBatchBarcode = (id: number, fmt: 'png' | 'svg' = 'png') => {
    const url = EndPoints.BATCHES.BARCODE_BATCH.replace(':id', id.toString()) + `?fmt=${fmt}`;
    window.open(url, '_blank');
  };

  const previewBatchBarcode = async (id: number, fmt: 'png' | 'svg' = 'png') => {
    const url = EndPoints.BATCHES.BARCODE_BATCH.replace(':id', id.toString()) + `?fmt=${fmt}`;
    const headers = getFetchDefaultHeaders(); // incluye Authorization

    const res = await fetch(url, { headers });
    if (!res.ok) {
      // opcional: intenta leer JSON de error
      try {
        const err = await res.json();
        throw new Error(err?.message ?? `Error HTTP ${res.status}`);
      } catch {
        throw new Error(`Error HTTP ${res.status}`);
      }
    }

    const blob = await res.blob();
    const blobUrl = URL.createObjectURL(blob);
    window.open(blobUrl, '_blank');

    // liberamos memoria luego de un rato
    setTimeout(() => URL.revokeObjectURL(blobUrl), 15000);
  };

  return {
    fetchingGetBatches,
    fetchingExportBatchesExcel,
    fetchingShowBatch,
    fetchingCreateBatch,
    fetchingStoreBatch,
    fetchingEditBatch,
    fetchingUpdateBatch,
    fetchingDeleteBatch,
    fetchingActiveBatch,
    fetchingCloneBatch,
    openBatchBarcode,
    previewBatchBarcode,
    getBatches,
    exportBatchesExcel,
    // showBatch,
    createBatch,
    storeBatch,
    editBatch,
    updateBatch,
    deleteBatch,
    activeBatch,
    cloneBatch,
  };
};

export default useBatchService;
